/**
 * Created by ianandersen on 4/6/17.
 */

import React from 'react';

class Author extends React.Component {
  constructor(props) {
    super(props);
    this.text = props.text;
  }

  render() {
    return this.text ? (
      <h4 style={{marginTop: '0'}}>{this.text}</h4>
    ) : null;
  }
}

export default Author;
